import React from "react";

export default function Policy() {
  return (
    <div className="w-full  h-screen flex flex-col items-center justify-end bg-color-primary-B">
      <div className="relative w-full h-[20vw] flex items-center justify-center">
        <h1 className="text-[#F4F4F4] font-font_primary_A text-[5.5vw] leading-[7vw] font-bold">
          سیاست‌نامه حریم خصوصی
        </h1>
      </div>
      <div className="relative w-full h-full mb-[3.7vw] text-justify px-[3.7vw] font-font_primary_A overflow-auto">
        <p className="text-[3.5vw]">
          اسکارپین به حریم خصوصی کاربران خود احترام می‌گذارد و حفظ اطلاعات
          کاربران بسیار حائز اهمیت است. از آنجا که جمع‌آوری و پردازش اطلاعات
          کاربران بخش غیرقابل اجتنابی در فرایندهای مبتنی بر گوشی همراه و اینترنت
          است لذا به‌منظور آگاهی کامل از سیاست و عملکرد اسکارپین، مطالعه این سند
          تحت عنوان «سیاست‌نامه حریم خصوصی» ضروری است. اسکارپین از سال 1400 با
          هدف پایش سلامت وسائل نقلیه توسط جوانان خلاق و توانمند در شرکت «پرشیا
          ایده و صنعت» طراحی و ساخت شده است. اسکارپین یک سامانه پویا و هوشمند
          بوده که براساس میزان مصرف کاربران وسائل نقلیه و با ساده سازی فرآیند
          تعویض قطعات و اقلام مصرفی به حفظ و نگهداری وسائل نقلیه کمک می‌نماید.
          همچنین اسکارپین این امکان را به کاربران خود می‌دهد تا در هر زمان از
          شبانه‌روز از طریق اپلیکیشن به سهولت بتوانند آخرین وضعیت سلامت وسائل
          نقلیه خود را مشاهده و جهت رفع نیاز‌های وسیله نقلیه خود به تعمیرگاه‌های
          معتبر و در دسترس مراجعه نمایند. در این سند، منظور از «اسکارپین» و
          «ما»، شرکت پرشیا ایده و صنعت با شماره ثبت 247919 است.
        </p>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - ثبت اطلاعات کاربران
        </h4>
        <p className="text-[3.5vw]">
          اطلاعات ممکن است توام با نصب و/یا استفاده شما از خدمات در سامانه
          اسکارپین ثبت شود به‌طوری‌که ممکن است اطلاعات شما به شکل مستقیم (هنگام
          ایجاد حساب کاربری، ثبت نظر، تماس و مکاتبه با پشتیبانی و یا تکمیل هر
          فرم یا ورود اختیاری اطلاعات) و یا توسط تعمیرگاه‌ها به شکل غیرمستقیم
          (هنگام ایجاد/ثبت وسیله‌نقلیه جدید) دریافت گردد.
          <br />
          <p className="text-[3.5vw] pr-[3.7vw]">
            1. اطلاعاتی که هنگام راه‌اندازی نرم‌افزار یا ایجاد حساب کاربری
            جمع‌آوری می‌شوند: اطلاعاتی که توسط اسکارپین (هنگام راه‌اندازی
            نرم‌افزار یا ایجاد حساب کاربری) جمع‌آوری می‌شوند شامل موارد ذیل است:
          </p>
        </p>
        <ul className="text-[3.5vw] pr-[7.4vw]">
          <li>
            - مشخصات دستگاه از قبیل نوع دستگاه، زبان، نوع سیستم عامل و اندازه
            رزولیشن مانیتور دستگاه شما؛
          </li>
          <p>
            مشخصات دستگاه صرفاً به‌منظور تحلیل اطلاعات سخت افزاری برای طراحی و
            بهبود رابط کاربری و ارائه خدمات متفاوت تر و بهتر سامانه اسکارپین
            مورد استفاده قرار می‌گیرد.
          </p>
          <li>
            - اطلاعات فنی و گزارش‌های سرور شامل آدرس پروتکل اینترنت (IP)، نوع
            شبکه و نوع و نسخه مرورگر؛
          </li>
          <li>
            - اسکارپین ممکن است بر روی مرورگر شما کوکی ذخیره کرده تا در مراجعات
            بعدی شما به سامانه از آن استفاده نماید.
          </li>
        </ul>
        <p className="text-[3.5vw] pr-[3.7vw]">
          2. اطلاعاتی که بعد از ایجاد حساب کاربری در اختیار اسکارپین قرار
          می‌گیرد: اطلاعاتی که توسط اسکارپین (بعد از ایجاد حساب کاربری) جمع‌آوری
          می‌شوند شامل موارد ذیل است:
        </p>
        <ul className="text-[3.5vw] pr-[3.7vw]">
          <li>
            - اطلاعاتی که برای ایجاد حساب کاربری در سامانه اسکارپین ضروری است
            شامل شماره تلفن همراه، کد یکبار مصرف اعتبارسنجی (OTP)، نام و نام
            خانوادگی یا سایر اطلاعاتی که شما در اختیار بازار قرار می‌دهید؛
          </li>
          <li>
            - مشخصات وسائل‌نقلیه شما از قیبل شماره پلاک، تاریخ تولید، شرکت
            سازنده و نوع وسائل‌نقلیه، کیلومتر کارکرد و میانگین کارکرد ماهیانه
            وسائل‌نقلیه شما؛
          </li>
          <li>- وضعیت قطعات و اقلام مصرفی وسائل‌نقلیه شما؛</li>
          <li>- سوابق کلیه سرویس‌های انجام شده وسائل‌نقلیه شما؛</li>
          <li>- امتیاز و نظراتی که در سامانه اسکارپین ثبت می‌نمایید؛</li>
          <li>- مکاتبات شما در ارتباط با تیم پشتیبانی؛</li>
        </ul>
        <p className="text-[3.5vw] pr-[3.7vw]">
          در صورتی که شما مایل نیستید اطلاعات شما در اختیار اسکارپین قرار گیرد،
          لطفا از نصب نرم‌افزار اسکارپین و/یا ایجاد حساب کاربری و ثبت اطلاعات
          شخصی در سایت و نرم‌افزار اسکارپین خودداری نمایید.
        </p>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - استفاده از اطلاعات کاربران
        </h4>
        <p className="text-[3.5vw]">
          موارد عمده استفاده از اطلاعاتی که توسط اسکارپین جمع‌آوری و/یا در
          اختیار اسکارپین قرار داده می‌شوند شامل موارد ذیل است:
        </p>
        <ul className="text-[3.5vw] pr-[3.7vw]">
          <li>- ارائه، نگهداری و بهبود کیفیت خدمات؛</li>
          <li>
            - ارزیابی عملکرد سایت و نرم‌افزار اسکارپین و رفع اشکالات آن‌ها در
            نسخه‌های آتی؛
          </li>
          <li>
            - بهبود تجربۀ کاربری از طریق انطباق نرم‌افزار اسکارپین با نیازها و
            شرایط کاربر و سیستم‌عامل‌های مورد استفاده در دستگاه‌های متنوع
            کاربران؛
          </li>
          <li>
            - برقراری ارتباط بین کاربران با تعمیرگاه‌ها به‌منظور انجام
            سروریس‌های دوره‌ای و ضرروی وسیله‌نقلیه؛
          </li>
          <li>- مکاتبات و تماس با کاربران توسط تیم پشتیبانی؛</li>
        </ul>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - امنیت اطلاعات کاربران
        </h4>
        <p className="text-[3.5vw]">
          یکی از اولویت‌های اصلی اسکارپین محافظت از اطلاعات حساب کاربران و
          جلوگیری از دسترسی‌های غیرمجاز به این اطلاعات است. به‌طوری‌که:
        </p>
        <ul className="text-[3.5vw] pr-[3.7vw]">
          <li>- خدمات سامانه اسکارپین با SSL رمزگذاری شده‌اند؛</li>
          <li>
            - به‌‌منظور ورود به حساب کاربری در بازار از رمز عبور یک‌بار مصرف
            (OTP) استفاده می‌شود که تنها با دسترسی به شماره تلفن همراهی که از
            طریق آن در اسکارپین، حساب کاربری خود را ایجاد کرده‌اید امکان‌پذیر
            است؛
          </li>
          <li>
            - اطلاعات حساب یا کارت بانکی که در زمان پرداخت وارد می‌کنید، در
            درگاه بانکی وارد می‌شوند و به هیچ‌ عنوان در اسکارپین دریافت و ذخیره
            نخواهند شد و از طریق درگاه بانکی مورد استفاده خواهند بود.
          </li>
          <li>
            - علی‌رغم تمام رویه‌های ایمنی که اسکارپین به هنگام ارائه خدمات اتخاذ
            کرده است ولی متاسفانه تدابیر امنیتی را نمی‌توان به صورت صد در صدی
            تضمین نمود، بنابراین مقتضی است:
          </li>
          <ol className="text-[3.5vw] pr-[3.7vw]">
            <li>
              1. از اطلاعات حساب کاربری خود محافظت کرده و آن‌ها را در اختیار
              اشخاص ثالث قرار ندهید؛
            </li>
            <li>
              2. در صورت وقوع سرقت گوشی همراه و همچنین پیش از واگذاری شماره تلفن
              همراهی که با آن حساب کاربری ایجاد کرده‌اید، موضوع را به اسکارپین
              اطلاع دهید تا حساب کاربری شما تعلیق شده یا اطلاعات موجود در آن
              تغییر کند. در غیر این صورت و در موارد دسترسی اشخاص ثالث به رمز
              عبور شما، تمامی مسئولیت هرگونه استفاده یا سوءاستفاده از حساب
              کاربری شما به عهدۀ شخص شماست و اسکارپین هیچ‌گونه مسئولیتی در این
              مورد ندارد.
            </li>
          </ol>
        </ul>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - در اختیار قراردادن اطلاعات کاربران
        </h4>
        <p className="text-[3.5vw]">
          تمامی اطلاعات شخصی شما نزد ما محفوظ خواهد ماند و در اختیار افراد یا
          سازمان‌های دیگری قرار نخواهد گرفت و تنها ممکن است اسکارپین در راستای
          مطابقت عملکردش با قوانین و مقررات کشور اطلاعات کاربران را در جریان
          رسیدگی قضایی و/یا در پاسخ به دستور مراجع قضایی ذی‌صلاح در اختیار
          نهادهای ذی‌ربط قرار دهد.
        </p>
        <p className="text-[3.5vw]">
          همچنین اسکارپین به‌‌‌‌منظور ارائه خدمات و سنجش وضعیت وسائل‌نقلیه شما،
          اطلاعات سرویس‌های گذشته و وضعیت قطعات و اقلام مصرفی وسیله‌نقلیه شما را
          در زمان مراجعه به تعمیرگاه جهت انجام تعویض قطعات و تعمیرات، تنها در
          اختیار تعمیرگاهانی که با ما همکاری دارند و پس از سنجش‌های گوناگون
          تأیید شده‌اند قرار داده خواهد شد.
        </p>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - پرسش‌ها و پیشنهادها
        </h4>
        <p className="text-[3.5vw]">
          در صورتی که درباره این سیاست‌نامه پرسشی وجود دارد یا پیشنهادهایی برای
          تغییرات و بهبود آن‌ها دارید، شما می‌توانید از طریق ارتباط با ما،
          پرسش‌ها و پیشنهادهای خود را با تیم اسکارپین در میان بگذارید.
        </p>
        <h4 className="text-[4vw] font-bold mt-[2.5vw]">
          - تغییرات سیاست‌نامه حریم خصوصی
        </h4>
        <p className="text-[3.5vw]">
          این سند مطابق با آخرین تغییرات قوانین و مقررات موضوعه کشور تدوین شده و
          مبیّن کلیه حقوق شما تحت قانون تجارت الکترونیکی مصوب ۱۳۸۲ ذی‌ربط است.
        </p>
        <p className="text-[3.5vw]">
          این سند ممکن است دستخوش تغییرات و تجدیدنظر شود به‌طوری‌که اسکارپین حق
          دارد در هر زمان بدون اطلاع قبلي در متن این سیاست‌نامه تغييرات ايجاد
          نمیاد. در صورتی که اطلاع‌رسانی تغییرات به موجب قانون الزامی باشد، این
          تغییرات از طریق حساب کاربری یا ایمیل به کاربران اطلاع داده خواهد شد
          ولیکن کاربران موظف‌اند با مراجعه مداوم به اين متن، از تغييرات آن مطلع
          گشته و در صورت مخالفت با آن، درخواست قطع سرويس خود را نمايند و یا از
          سایت و نرم‌افزار اسکارپین خارج شده و به آن مراجعه نکنند.{" "}
        </p>
        <p className="text-[3.5vw]">
          این سند، آخرین بار در تاریخ ۱ فروردین 1401 مورد بازبینی و به‌روزرسانی
          قرار گرفته شده است.
        </p>
      </div>
      <div className="relative mb-[1.8vh] w-full h-[12vw] flex items-center justify-center">
        <button
          className="w-[94vw] h-[12vw] flex items-center justify-center bg-[#153038] text-[5.5vw] text-[#F4F4F4] font-font_primary_A rounded-[1.8vw]"
          onClick={() => {
            window.history.back();
          }}
        >
          بازگشت
        </button>
      </div>
    </div>
  );
}
